import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import 'rxjs/add/operator/map';

import { Client } from './client.model';
import { ClientService } from './client.service';

@Injectable()
export class ClientResolver implements Resolve<Client> {
  constructor(private clientService: ClientService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Client> {
    return this.clientService.getById(route.paramMap.get('clientId'));
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/clients/client.resolver.ts